import { useState } from "react"
import SegmentedInput from "../widgets/SegmentedInput"
import LabeledTextarea from "../widgets/LabeledTextarea"
import { SpaceBetween } from "@cloudscape-design/components"
import { upsert } from "../hooks/useQueryData"
import { NowDB } from "../utils"

export const PhoneTaskSettings = {size: "medium", title: "Phone Contact Task"}

export default function PhoneTask({values, setMessage, execRef}: {values: any, setMessage: (s: string, t: string) => void, execRef: React.MutableRefObject<() => Promise<string>>}) {
    setMessage("As you talk to the customer, take notes here.", "info")
    const [result, setResult] = useState('')
    const [notes, setNotes] = useState('')

    let valid = true
    function validate(value: string, label: string): boolean {
        return true
        // const thisValid: boolean = value?.length > 0
        // if (!thisValid) {valid = false; setMessage("Please provide values for all required fields")}

        // return thisValid
    }

    async function execute(): Promise<string> {
        if (!result) return "ERROR: Please select a Result for this call"
        if (!notes ) return "ERROR: Please enter Notes for this call"

        const fullNotes = "Phone call result: " + result + ". \r\n" + notes

        // Create Activity
        await upsert('Activity', {
            ForId: "Case:" + values.Case._id,
            CaseId: values.Case._id,
            Type: "Contact",
            Description: fullNotes,
            On: NowDB(),
        })

        upsert('Communication', {
            Type: "Phone", 
            Subject: "",
            ToName: values.Contact?.FirstName + " " + values.Contact?.LastName,
            ToAddress: values.Contact?.Phone,
            Result: result,
            Body: notes, 
            CaseId: values.Case._id, 
            ContactId: values.Contact._id,
        })


        return '' // No error. Successful execution
    }
    execRef.current = execute

    return (
        <SpaceBetween direction="vertical" size="m">
            <h3>Client: {values.Contact?.FirstName + " " + values.Contact?.LastName} --- Phone: {values.Contact?.Phone}</h3>
            <SegmentedInput validate={validate} readOnly={false}
                label="Result of call"
                onChange= {(v) => setResult(v)}
                value={result}
                options="Client Called In;Reached Customer;Left Voicemail;No Answer"
            />
            <LabeledTextarea label="Notes" readOnly={false} value={notes} validate={validate} rows={10}
                onChange={ value => setNotes(value) } />
        </SpaceBetween>
    )
}
